
import { useEffect, useState } from "react"
import styled from "styled-components"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    textarea{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        resize: vertical;
        min-height: 100px;
        max-height: 150px;
        border-radius: 5px;
        line-height: 1.4;

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    textarea:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        top: 14px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const InputTextareaContent = ({data, setData, name, inputWidth, labelText, disabled}) => {

    const handleChange = (e) => {
        setData(e.target.value);
      };

  return (
    <Container inputWidth={inputWidth} value={data}>
        <textarea disabled={disabled} id={"text"} onChange={handleChange} value={data} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>
    </Container>
  )
}

export default InputTextareaContent